import type { Role } from '@/entities/user';

export const settingsAccessRoles = ['admin'] as const satisfies readonly Role[];
